module.exports = __webpack_public_path__ + "mk.f5e20aef616a68263d01.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mk.svg
// module chunks = styles